export const getSearchParams = (search: string, value: string): string => {
  if (search.includes(value)) {
    const searchParams = search.split('?')[1].split('&');
    const param = searchParams.find((item) => item.includes(value));
    return param ? param.split('=')[1] : null;
  }
  return null;
};
